module.exports = __webpack_public_path__ + "static/left arrow-5a1b252ade735a785531a0e4f7cbea18.png";